import PropTypes from 'prop-types';

// Should match shape of address validator in Core
export const addressPropType = {
  address_type: PropTypes.string.isRequired,
  line_1: PropTypes.string,
  line_2: PropTypes.string,
  city: PropTypes.string.isRequired,
  county: PropTypes.string,
  state: PropTypes.string.isRequired,
  postal_code: PropTypes.string,
  country: PropTypes.string.isRequired,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  is_primary: PropTypes.bool
};
export const contactPropType = PropTypes.shape({
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    extension: PropTypes.string,
    is_primary: PropTypes.bool,
    phone_type: PropTypes.string,
    country_code: PropTypes.string,
    phone_number: PropTypes.string,
    acceptable_communication_types: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.number
  })),
  email_addresses: PropTypes.arrayOf(PropTypes.shape({
    is_primary: PropTypes.bool,
    email_address: PropTypes.string,
    acceptable_communication_types: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.number
  })),
  date_of_birth: PropTypes.number,
  gender: PropTypes.string,
  addresses: PropTypes.arrayOf(PropTypes.shape(addressPropType)),
  household: PropTypes.shape({
    total: PropTypes.number,
    adults: PropTypes.number,
    children: PropTypes.number
  })
});

// hours
const openAndClosePropType = PropTypes.shape({
  opens: PropTypes.string,
  closes: PropTypes.string
});
export const hoursPropType = PropTypes.shape({
  monday: PropTypes.arrayOf(openAndClosePropType),
  tuesday: PropTypes.arrayOf(openAndClosePropType),
  wednesday: PropTypes.arrayOf(openAndClosePropType),
  thursday: PropTypes.arrayOf(openAndClosePropType),
  friday: PropTypes.arrayOf(openAndClosePropType),
  saturday: PropTypes.arrayOf(openAndClosePropType),
  sunday: PropTypes.arrayOf(openAndClosePropType)
});

// services
export const flatServicesPropType = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  parent_id: PropTypes.string,
  parent_code: PropTypes.string,
  name: PropTypes.string,
  code: PropTypes.string,
  taxonomy: PropTypes.string,
  is_sensitive: PropTypes.bool
}));
export const filterOptionsPropType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  initial: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    initial: PropTypes.bool
  }))
}));
//# sourceMappingURL=propTypes.js.map